// 🚫 DEFAULT RAILS INCLUDES
// This section represents the default includes for a Rails application. Bullet Train's includes and your own
// includes should be specified at the end of the file, not in this section. This helps avoid merge conflicts in the
// future should the framework defaults change.

import * as ActiveStorage from "@rails/activestorage"
import "@hotwired/turbo-rails"
import "./controllers"
import "./channels"

ActiveStorage.start()

// 🚫 DEFAULT BULLET TRAIN INCLUDES
// This section represents the default settings for a Bullet Train application. Your own includes should be specified
// at the end of the file. This helps avoid merge conflicts in the future, should we need to change our own includes.

import "./support/jstz";
import { installTransientScrollbars } from "./support/transientScrollbars";

import "@bullet-train/bullet-train"
import "@bullet-train/bullet-train-sortable"

require("@icon/themify-icons/themify-icons.css")

import { trixEditor } from "@bullet-train/fields"
trixEditor()
installTransientScrollbars()

// ✅ YOUR APPLICATION'S INCLUDES
// If you need to customize your application's includes, this is the place to do it. This helps avoid merge
// conflicts in the future when Rails or Bullet Train update their own default includes.

// Fix pagy pagination links - disable Turbo when data-turbo="false" is on container
// This ensures pagination links do full page reloads when needed
const fixPagyLinks = () => {
  // Handle containers with data-turbo="false" (for full page navigation)
  document.querySelectorAll(".pagy-nav-container[data-turbo='false']").forEach(container => {
    container.querySelectorAll("a").forEach(link => {
      if (!link.hasAttribute('data-turbo')) {
        link.setAttribute('data-turbo', 'false')
      }
    })
  })

  // Handle containers with specific turbo-frame targets
  document.querySelectorAll(".pagy-nav-container[data-turbo-frame]").forEach(container => {
    const turboFrame = container.dataset.turboFrame
    container.querySelectorAll("a").forEach(link => {
      if (!link.hasAttribute('data-turbo-frame')) {
        link.setAttribute('data-turbo-frame', turboFrame)
      }
    })
  })
}

document.addEventListener("turbo:load", fixPagyLinks)
document.addEventListener("turbo:render", fixPagyLinks)
document.addEventListener("DOMContentLoaded", fixPagyLinks)
